import { useEffect, useState } from "react";

export const GENESIS_DATE = new Date("2026-10-28T00:00:00Z");

export const pad2 = (n) => String(n).padStart(2, "0");

/* Shared Genesis countdown — drives the hero badge and modal countdowns */
export function useGenesisCountdown() {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    const diff = Math.max(0, GENESIS_DATE.getTime() - now);
    return {
        days: Math.floor(diff / 86400000),
        hours: Math.floor(diff / 3600000) % 24,
        minutes: Math.floor(diff / 60000) % 60,
        seconds: Math.floor(diff / 1000) % 60,
    };
}
